/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      $( 'select[name="services-archive__select"]' ).on( 'change', function() {
        const targetId = $( this ).val();

        if ( $( targetId ).length ) {
          scrollToElement( targetId );
        }
      } );

      $( 'a' ).on( 'click', function( e ) {
        const targetId = $( this ).attr( 'href' );
        if ( targetId && targetId[0] === '#' ) {
          e.preventDefault();
          if ( $( targetId ).length ) {
            scrollToElement( targetId );
          }
        }
      } );

      function scrollToElement( targetId ) {
        if ( $( targetId ).length ) {
          const topOfTarget = $( targetId ).offset().top - 50 - $( '.navbar' ).height();
          $( 'html, body' ).animate( {scrollTop: topOfTarget}, 500 );
          $( targetId ).attr( 'tabindex', '0' );
          $( targetId ).trigger( 'focus' );
          $( targetId ).removeAttr( 'tabindex' );
        }
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'services', COMPONENT );
} )( app );
